import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const replaceBrWithNewline = (string = '') => {
    const withNewLines = string.replace(/<br[^>]*>/gi, '\n');
    return withNewLines.replace(/<\/br[^>]*>/gi, '');
};
i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    resources: {
        en: {
            settings: {
                title: 'Settings',
                language: 'Language',
                toggleTheme: 'Toggle theme',
                theme: 'Theme'
            },
            date: {
                sundayShort: 'Su',
                mondayShort: 'Mo',
                tuesdayShort: 'Tu',
                wednesdayShort: 'We',
                thursdayShort: 'Th',
                fridayShort: 'Fr',
                saturdayShort: 'Sa'
            },
            common: {
                currentLanguage: 'The current language is "{{lng}}"',
                play: 'Play',
                pause: 'Pause',
                language: 'English',
                English: 'English',
                en: 'English',
                Spanish: 'Spanish',
                es: 'Spanish',
                addToList: 'Add to list',
                share: 'Share',
                more: 'More like this',
                dirAndCast: 'Director & Cast',
                back: 'Back',
                loading: 'Loading',
                apiError: 'Something went wrong. Please try again later',
                viewAll: 'View all',
                browse: 'Browse',
                nowOnTv: 'Now on TV',
                myContent: 'My content',
                home: 'Home',
                videostore: 'Videostore',
                minRemaining: 'min. remaining',
                cancel: 'Cancel',
                liveTv: 'Live TV',
                live: 'Live',
                movies: 'Movies',
                videoQuality: 'Video quality',
                aspectRatio: 'Aspect ratio',
                series: 'SERIES'
            },
            home: {
                continueWatching: 'Continue Watching',
                comedies: 'Comedies',
                actionMovies: 'Action Movies',
                tvGuideButtonTitle: 'TV Guide'
            },
            menu: {
                home: 'HOME',
                moviesAndSeries: 'MOVIES & SERIES',
                search: 'SEARCH',
                myList: 'MY LIST',
                settings: 'SETTINGS'
            },
            login: {
                loginTitle: 'Login',
                invalidUsername: 'Invalid username',
                passwordIsEmpty: 'Password is empty',
                startWithMagioGo: 'Start with Magio GO',
                getStartedNow: 'Get started now',
                newToMagioGo: 'New to Magio GO?',
                forgottenPassword: 'Forgotten password',
                logOut: 'Log out',
                rememberPassword: 'Remember password',
                logoutQuestionShort: 'Log out?',
                logoutQuestionLong: 'Are you sure you want to log out?'
            }
        }
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ','
    },
    react: {
        wait: true
    }
});

export const t = (key) => replaceBrWithNewline(i18n.getFixedT()(key));

export default i18n;
